import React, { useEffect, useState } from "react";
import { Select, Text, Flex, Spacer } from "@chakra-ui/react";
import { getFormSubmissions } from "../../api/formSubmissionApi";
const Header = ({ templates, onChangeFormHandler, selectFormId }) => {
  console.log("🚀 ~ file: Header.js ~ line 4 ~ Header ~ templates", templates);
  const [url, setUrl] = useState("");
  const [urlVisible, setUrlVisible] = useState("");

  const renderTemplateOptions = () => {
    const options = templates.map(({ id, title }) => {
      return (
        <option key={id} value={id}>
          {title}
        </option>
      );
    });
    return options;
  };
  useEffect(() => {
    getFormSubmissions()
      .then((data1) => {
        var data = Object.values(data1);
        var newArr = [];
        for (let i = 0; i < data.length; i++) {
          var tempObj = {};
          for (let j = 0; j < Object.keys(data[i]).length; j++) {
            var ele = Object.keys(data[i]);
            var val = Object.values(data[i]);
            if (typeof val[j] == "object") {
              if (ele[j] == "address") {
                addAddress(tempObj, val[j]);
              } else {
                addDefaultFields(tempObj, val[j]);
              }
            } else {
              tempObj[ele[j]] = val[j];
            }
          }
          newArr.push(tempObj);
        }
        function addAddress(obj, obj2) {
          for (let i = 0; i < Object.keys(obj2).length; i++) {
            obj[Object.keys(obj2)[i]] = Object.values(obj2)[i];
          }
        }
        function addDefaultFields(obj, arr) {
          for (let i = 0; i < arr.length; i++) {
            var str = Object.keys(arr[i])[0];
            const index = str.indexOf(".", str.indexOf(".") + 1);
            var str2 = str.slice(index + 1);
            //obj[str2] = Object.values(arr[i])[0];
            if (typeof Object.values(arr[i])[0] == "object") {
              obj[str2] = Object.values(arr[i])[0].join(";");
            } else {
              obj[str2] = Object.values(arr[i])[0];
            }
          }
        }

        var expArr = newArr.filter((obj) => {
          if (obj.formId == selectFormId) return true;
          return false;
        });
        console.log("========>exp array >>>>>>>>>>>>>>>>>", expArr);

        var lenArr = [];
        for (let i = 0; i < newArr.length; i++) {
          lenArr.push(Object.keys(newArr[i]).length);
        }
        const max = Math.max(...lenArr);

        const index = lenArr.indexOf(max);
        const key = Object.keys(newArr[index]);
        const keys = key.filter(function (ele) {
          return !["id", "formId", "filter"].includes(ele);
        });
        const commaSeparatedString = [
          keys.join(","),
          expArr.map((row) => keys.map((key) => row[key]).join(",")).join("\n"),
        ].join("\n");

        const csvBlob = new Blob([commaSeparatedString]);
        setUrl(URL.createObjectURL(csvBlob));
        setUrlVisible(true);
      })
      .catch((err) => {
        console.log(err);
        setUrl("");
        setUrlVisible(false);
      });
  }, [selectFormId]);
  return (
    <Flex>
      <Flex direction="column" ml="4" mt="3">
        <Text textTransform="uppercase">select form</Text>
        <Select
          onChange={(e) => onChangeFormHandler(e.target.value)}
          value={selectFormId}
          mt="2"
          w="150px"
        >
          {renderTemplateOptions()}
        </Select>
      </Flex>
      <Spacer />

      {urlVisible ? (
        <div style={{ marginRight: "16px" }}>
          <br></br>
          <br></br>
          <a href={url} download={"download.csv"}>
            <span className="dashicons dashicons-migrate"></span>Export All(CSV)
          </a>
        </div>
      ) : null}
    </Flex>
  );
};

export default Header;
